import { combineReducers, Action, Reducer } from 'redux'
import auth, { AuthState } from './slices/base/user-management/auth'
import base, { BaseState } from './slices/base'
import locale, { LocaleState } from './slices/base/language-management/locale/localeSlice'
import theme, { ThemeState } from './slices/base/theme/themeSlice'
import RtkQueryService from '@/lib/rtkQuery'
import table, { TableState } from './slices/base/table/tableSlice'
import tab, { TabState } from './slices/base/tab/tabSlice'
import mts, { MtsState } from './slices/it-process/application-management/mts/mtsSlice'
import loader, { LoadingState } from './slices/base/loader/loaderSlice'
import navigation, {
    NavigationState,
} from './slices/base/navigation/navigationSlice'
import detailsTabStrips, {
    DetailsTabStripsState,
} from './slices/it-process/application-management/dts/detailsTabStripsSlice'
import navigationContext, {
    NavigationContextState,
} from './slices/it-process/application-management/mms/navigationContextSlice'
import obj, { ObjState } from './slices/it-process/application-management/obj/objSlice'
import sdui, { SDUIState } from './slices/it-process/application-management/sdui/sduiSlice'
import licenseMgt, {
    LicenseMgtState,
} from './slices/base/license-management/licenseMgtSlice'
import licBa, { LicBaState } from './slices/base/license-management/licBaSlice'

export type RootState = {
    auth: AuthState
    base: BaseState
    locale: LocaleState
    theme: ThemeState
    table: TableState
    tab: TabState
    mts: MtsState
    loader: LoadingState
    navigation: NavigationState
    dts: DetailsTabStripsState
    navigationContext: NavigationContextState
    obj: ObjState
    sdui: SDUIState
    licenseMgt: LicenseMgtState
    licBa: LicBaState
    /* eslint-disable @typescript-eslint/no-explicit-any */
    [RtkQueryService.reducerPath]: any
}

export interface AsyncReducers {
    [key: string]: Reducer<any, Action>
}

const staticReducers = {
    auth,
    base,
    locale,
    theme,
    table,
    tab,
    mts,
    loader,
    navigation,
    dts: detailsTabStrips,
    navigationContext,
    obj,
    sdui,
    licenseMgt,
    licBa,

    [RtkQueryService.reducerPath]: RtkQueryService.reducer,
}

const rootReducer =
    (asyncReducers?: AsyncReducers) => (state: RootState, action: Action) => {
        const combinedReducer = combineReducers({
            ...staticReducers,
            ...asyncReducers,
        })
        return combinedReducer(state, action)
    }

export default rootReducer
